<template>
    <div>
        <div class="form-group text-center" v-if="templateArgs.noDataFound">
            <p
                class="text-secondary mt-2"
                v-if="templateArgs.noDataFound"
            >{{ templateArgs.noDataFound }}</p>
            <p
                class="text-secondary"
                v-if="templateArgs.createQuestion"
            >{{ templateArgs.createQuestion }}</p>
        </div>
		<div v-if="templateArgs.btns" class="text-center">
			<div class="btn-group" role="group" aria-label="Btns group">
				<div v-for="btn in templateArgs.btns" :key="btn.name">
					<button
						type="button"
						@click="btn.clickHandler(templateArgs)"
						:title="btn.tooltip"
						data-toggle="tooltip"
						:class="btn.class"
						:data-placement="!btn.tooltipPlacement ? 'top' : btn.tooltipPlacement"
						v-if="btn.show"
					>
						<i :class="btn.icon"></i>
						{{btn.text}}
					</button>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
export default {
    name: "nodataTemplate",
    props: {},
    data() {
        return {
            templateArgs: {},
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style>
</style>
